export default __webpack_public_path__ + "static/winter13-f4b6ffd6ceee68ef3ba18a33a68663f1.webp";